import {
  ADD_Holiday,
  GET_Holiday,
  UPDATE_Holiday,
  DELETE_Holiday,
} from "../type";
import { InsertData } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";
export const CreateHolidayAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(`/api/Holiday`, data);
    dispatch({
      type: ADD_Holiday,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADD_Holiday,
      payload: "Error" + e,
    });
  }
};
export const GetAllHolidayAction = (body) => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/Holiday`,body);
    dispatch({
      type: GET_Holiday,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_Holiday,
      payload: "Error" + e,
    });
  }
};
export const UpdateHolidayAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/Holiday`, body);
    dispatch({
      type: UPDATE_Holiday,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_Holiday,
      payload: "Error" + e,
    });
  }
};

export const DeleteHolidayAction = (Id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/Holiday?id=${Id}`);
    dispatch({
      type: DELETE_Holiday,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETE_Holiday,
      payload: "Error" + e,
    });
  }
};
